import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';

import { getTagsList } from 'store/ProductCatalog/selectors';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

export const Tag = ({ children, url }) => (
  <span className={cx('tag')}>
    <a href={url}>{children}</a>
  </span>
);

Tag.propTypes = {
  children: PropTypes.node,
  url: PropTypes.string,
};

export class TagsLayout extends React.PureComponent {
  state = { show: false };

  render() {
    const { list } = this.props;
    return (
      <div className={cx('container')}>
        <div className={cx('heading')}>Подборки</div>
        <div className={cx('content')}>
          {list.map(({ name, url }, index) => (
            <Tag key={+index} url={url}>
              {name}
            </Tag>
          ))}
        </div>
      </div>
    );
  }
}

TagsLayout.propTypes = {
  list: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      url: PropTypes.string,
    }),
  ),
};

export const mapStateToProps = (state) => ({
  list: getTagsList(state),
});

export default connect(mapStateToProps)(TagsLayout);
